// https://drive.google.com/file/d/1NL9HJMxMWncQd5VOsdN3zBLVnyB2s9S8/view?usp=sharing
/* 使用方式
    import Column from '@/sag-core/grid_table/Column.js'

    const gdt = new core.GridDataTable();
    const api = new core.ApiSubscriber();
    api.readData = ()=>{
        console.log("不給你讀取");
        return []
    }
    gdt.subscribe('api', api);
    gdt.readData('api');
    gdt.columns.splice(0, 0, ...[
            new Column('employee', '員工工號').SetMiddle(),
            new Column('department', '部門代號').SetMiddle()
        ]);
*/



class Column {
    constructor(id, label){
        this.field = id;
        this.filterOptions = {
            enabled: false,
            placeholder: "Search"
        }
        this.label = label;
    }

    SetMiddle(){
        this.tdClass = "align-middle";
        return this;
    }

    SetType(type){
        switch(type){
            case 'datetime':
                this.type = 'date';
                this.dateInputFormat = 'yyyy-MM-ddEEEEEHH:mm:ss';
                this.dateOutputFormat = 'yyyy-MM-dd HH:mm:ss';
                break;
        }
        return this;
    }

    SetHidden(){
        this.hidden = true;

        return this;
    }

    SetWidth(w){
        this.width = `${w}px`;

        return this;
    }

    SetCellClass(cls){
        this.tdClass = cls;

        return this;
    }

    SetHeaderClass(cls){
        this.thClass = cls

        return this;
    }

    SetHtml(){
        this.html = true;

        return this;
    }
}
/**
 * 發佈
 */
class Publisher {
    constructor(){
        /**
         * 訂閱者清單
         * @protected
         * @type {Object.<string, Array.<Subscriber>>}
         */
        this.subscribers = {};
    }
    /**
     * 通知
     * @param {string} eventType
     */
    notify(eventType){
        return new Promise((result, reject)=>{
            if(this.subscribers[eventType] instanceof Array){
                this.subscribers[eventType].forEach(p=>{
                    p.update(this);
                })   
                result();
            }
            else{
                console.log(`the (eventType)'${eventType}' not registration.`);
                reject(`the (eventType)'${eventType}' not registration.`);
            }
        })
    }
    /**
     * 訂閱
     * @param {string} eventType
     * @param {Subscriber} subscriber
     */
    subscribe(eventType, subscriber){
        if(!this.subscribers[eventType]){
            this.subscribers[eventType] = [];
        }

        this.subscribers[eventType].push(subscriber);
    }
    /**
     * 取消訂閱
     * @param {string} eventType
     * @param {Subscriber} subscriber
     */
    unsubscribe(eventType, subscriber){
        if(this.subscribers[eventType] instanceof Array){
            this.subscribers[eventType].splice([this.subscribers[eventType].indexOf(subscriber)], 1);

            if(this.subscribers[eventType].length === 0){
                delete this.subscribers[eventType];
            }
        }
    }
}
/**
 * 訂閱者
 */
class Subscriber {
    /**
     * @param {Context} event
     */
    update(event){
        throw 'no override this method.';
    }
}
class ApiSubscriber extends Subscriber {
    constructor(){
        super();
    }
    /**
     * @virtual
     * @param {Publisher} event
     */
    update(event){
        return new Promise((result, reject)=>{
            if(event instanceof GridDataTable){
                let tmp = this[event.status + "Data"]();
                let tmpOpe = this.rowDataOperation(event);
                tmp = tmpOpe ? tmpOpe : tmp;
                if(tmp instanceof Promise){
                    tmp.then(res=>{
                        if(res instanceof Array){
                            event.rows.getData().splice(0, event.rows.getData().length, ...res);
                            result();
                        }
                        else{
                            // todo: 回傳的如果不是陣列，就會是create、delete、update
                            // ...
                        }
                    })
                }
                else{
                    if(tmp instanceof Array){
                        event.rows.getData().splice(0, event.rows.getData().length, ...tmp);
                        result();
                    }
                    else{
                        // todo: 回傳的如果不是陣列，就會是create、delete、update
                        // ...
                    }
                }
            }
            else
            {
                reject();
            }
        })
    }
    /** 
     * 對Grid Table Row Data進行操作
     * 需要外部覆寫，會傳入event參數會在read、create、update、delete各行為被呼叫
     * 若覆寫成功有回傳值(不為false的值)，將改變原本的CRUD操作
     * @virtual
     * @param {Publisher} event
     */
    rowDataOperation(event){}

    /** 
     * @virtual
     */
    readData(){
        return new Promise((res, rej)=>{
            res([]);
        })
    }
    /** 
     * @virtual
     */
    createData(){
        return new Promise((res, rej)=>{
            console.log("create data");
            this.readData().then(r=>{
                res(r);
            })
        })
    }
    /** 
     * @virtual
     */
    deleteData(){
        return new Promise((res, rej)=>{
            console.log("delete data");
            this.readData().then(r=>{
                res(r);
            })
        })
    }
    /** 
     * @virtual
     */
    updateData(){
        return new Promise((res, rej)=>{
            console.log("update data");
            this.readData().then(r=>{
                res(r);
            })
        })
    }
}
class TestApiSubscriber extends ApiSubscriber {
    constructor(){
        super()
        /** @protected */
        this.testData = [
            { Employee_WorkCode: '111113', Employee_CnName: '17002', Other: '111113 其他資訊 or 隱藏資訊' },
            { Employee_WorkCode: '110014', Employee_CnName: '17002', Other: '110014 其他資訊 or 隱藏資訊' },
            { Employee_WorkCode: '112024', Employee_CnName: '17002', Other: '112024 其他資訊 or 隱藏資訊' },
            { Employee_WorkCode: '110001', Employee_CnName: '17002', Other: '110001 其他資訊 or 隱藏資訊' },
        ];
    }
    changeTestData(n){
        switch(n){
            case 0:
                this.testData = [
                    { Employee_WorkCode: '999999', Employee_CnName: '17002' },
                    { Employee_WorkCode: '888888', Employee_CnName: '17002' },
                    { Employee_WorkCode: '777777', Employee_CnName: '17002' },
                    { Employee_WorkCode: '666666', Employee_CnName: '17002' },
                ];
                break;
            case 1:
                this.testData = [
                    { Employee_WorkCode: '543210', Employee_CnName: '17002' },
                    { Employee_WorkCode: '012345', Employee_CnName: '17002' },
                    { Employee_WorkCode: '665666', Employee_CnName: '17002' },
                    { Employee_WorkCode: '112233', Employee_CnName: '17002' },
                ];
                break;
        }
    }
    readData(){
        return new Promise((res, rej)=>{
            const that = this;
            console.log("read data");
            res(that.testData);
        })
    }
    /** 
     * @overrid
     */
    createData(){
        return new Promise((res, rej)=>{
            const that = this;
            console.log("create data");
            that.readData().then(r=>{
                that.testData.splice(0, 0, { Employee_WorkCode: '111113', Employee_CnName: '17002' });
                res(r);
            })
        })
    }
    /** 
     * @overrid
     */
    deleteData(){
        return new Promise((res, rej)=>{
            const that = this;
            console.log("delete data");
            that.readData().then(r=>{
                that.testData.splice(0, 1);
                res(r);
            })
        })
    }
    /** 
     * @overrid
     */
    updateData(){
        return new Promise((res, rej)=>{
            const that = this;
            console.log("update data");
            that.readData().then(r=>{
                if(that.testData.length) that.testData[0].Employee_CnName = "蔡明倫";
                res(r);
            })
        })
    }
}
class GridDataTable extends Publisher {
    /** @param {DataCreator} dataCreator */
    constructor(dataCreator){
        super();
        this.status = "empty";
        /** @type {RowsData} */
        this.rows = dataCreator.createRowsData();
        /** @type {ColumnsData} */
        this.columns = dataCreator.createColumnsData();
        /** @type {Array.<GridDataTable>} */
        this.children = []
    }
    /** 
     * 指認父親(單頭單身)
     * @param {GridDataTable} gdt
     */
    recognizeFather(gdt){
        const tar = gdt.children.find(e=>Object.is(e, this));
        if(!tar){
            gdt.children.push(this);
        }
    }
    /** 
     * 斷絕關係(單頭單身)
     * @param {GridDataTable} gdt
     */
    cutOffFather(gdt){
        const idx = gdt.children.indexOf(this);
        if(idx >= 0){
            gdt.children.splice(idx, 1);
        }
    }
    /** CRUD: Read */
    readData(eventType){
        this.status = "read";
        this.notify(eventType);
        for(const child of this.children){
            child.status = "read";
            child.notify(eventType);
        }
    }
    /** CRUD: Create */
    createData(eventType){
        this.status = "create";
        this.notify(eventType);
        for(const child in this.children){
            child.status = "create";
            child.notify(eventType);
        }
    }
    /** CRUD: Update */
    updateData(eventType){
        this.status = "update";
        this.notify(eventType);
        for(const child in this.children){
            child.status = "update";
            child.notify(eventType);
        }
    }
    /** CRUD: Delete */
    deleteData(eventType){
        this.status = "delete";
        this.notify(eventType);
        for(const child in this.children){
            child.status = "delete";
            child.notify(eventType);
        }
    }
}
/** @abstract */
export class DataCreator {
    /** 
     * 建立 Rows 資料 
     * @virtual
     * @returns {RowsData}
     */
    createRowsData(){
        return new RowsData();
    }
    /** 
     * 建立 Columns 資料 
     * @virtual
     * @returns {ColumnsData}
     */
    createColumnsData(){
        return new ColumnsData();
    }
}
export class RowsData {
    constructor(){
        /** @type {Object} */
        this.data = [];
    }
    /**
     * @virtual
     * @returns {Array}
     */
    getData(){
        return this.data;
    }
    /**
     * @virtual
     * @param {Array}
     */
    setData(array){
        this.data = array;
    }
}
export class ColumnsData {
    constructor(){
        /** @type {Object} */
        this.data = [];
    }
    /**
     * @returns {Array}
     */
    getData(){
        return this.data;
    }
    /**
     * @param {Array}
     */
    setData(array){
        this.data = array;
    }
}
class ArrayDataCreator extends DataCreator {
    constructor(){
        super();
    }
    /** 
     * 建立 Rows 資料 
     * @override
     * @returns {RowsData}
     */
    createRowsData(){
        return new ArrayRowsData();
    }
    /** 
     * 建立 Columns 資料 
     * @override
     * @returns {ColumnsData}
     */
    createColumnsData(){
        return new ArrayColumnsData();
    }
}
class ArrayRowsData extends RowsData {
    constructor(){
        super();
        /** @type {Object} */
        this.data = [];
    }
    /**
     * @override
     * @returns {Array}
     */
    getData(){
        return this.data;
    }
    /**
     * @override
     * @param {Array}
     */
    setData(array){
        this.data = array;
    }
}
class ArrayColumnsData extends ColumnsData {
    constructor(){
        super();
        /** @type {Object} */
        this.data = [];
    }
    /**
     * @override
     * @returns {Array}
     */
    getData(){
        return this.data;
    }
    /**
     * @override
     * @param {Array}
     */
    setData(array){
        this.data = array;
    }
}
/* 用法範例 */
    // const gdt = new GridDataTable(new ArrayDataCreator());
    // const api = new ApiSubscriber();
    // gdt.subscribe('api', api);
    // gdt.readData();

    // setTimeout(()=>{
    //     console.log(gdt.rows.getData());
    // }, 1000);
    // api.readData = ()=>{
    //     console.log("不給你讀取");
    //     return []
    // }
    // gdt.subscribe('api', api);
    // gdt.readData();
    // gdt.columns.splice(0, 0, ...[
    //     new Column('employee', '員工工號').SetMiddle(),
    //     new Column('department', '部門代號').SetMiddle()
    // ]);

export default {
    GridDataTable,
    ApiSubscriber,
    TestApiSubscriber,
    ArrayDataCreator,
    Column,
}

export { Column }